import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/** A missing asset answers 404, and a 400 can follow an already deleted file (the blob goes before the row). */
export const deleteAsset = async (
  scope: RequestScope,
  { id }: Readonly<{ id: number }>,
  options: WriteRequestOptions
): Promise<EndpointResponse<unknown>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<unknown>>(`assets/${id}`, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
